import { isNotNullOrUndefined, predicateNumber, predicateString } from 'utilities/isType.js';

export const parseNumberFromPrimitive = (item: string | number | undefined | null) => {
  if (isNotNullOrUndefined(item)) {
    if (predicateString(item)) {
      if (item !== '') {
        const value = parseFloat(item);
        const isNumber = !isNaN(value);
        return { isNumber, value };
      }
      return { isNumber: false, value: NaN };
    }
    const isNumber = !isNaN(item);
    return { isNumber, value: item };
  }
  return { isNumber: false, value: NaN };
};

/**
 * This is an unfortunate hack to get around some api requests returning a number or a string of a number
 * If it is a string we need to check if it is of a number.
 * https://stackoverflow.com/questions/175739/built-in-way-in-javascript-to-check-if-a-string-is-a-valid-number
 * Only works if the string only contains numeric characters, else it returns NaN.
 * If string is empty it is not a number
 * @example getNumberString('') : undefined
 * @example getNumberString('0') : 0
 * @example getNumberString('0foo') : 0
 * @example getNumberString('5.78') : 5.78
 * @returns {number | undefined} is the string a number
 */
export const getNumberString = (
  _n: number | string | undefined,
): { isNumber: true; value: number } | { isNumber: false; value: undefined } => {
  // just in case its a null
  const n = _n ?? undefined;
  if (n === undefined) {
    return {
      isNumber: false,
      value: undefined,
    };
  }
  if (predicateNumber(n)) {
    return {
      isNumber: true,
      value: n,
    };
  }
  // use parse float as we may use decimals
  const val = parseFloat(n);
  if (!isNaN(val)) {
    return {
      isNumber: true,
      value: val,
    };
  }
  return {
    isNumber: false,
    value: undefined,
  };
};
